export { default } from "./modal-tanya-marketing"